<template>
  <div>
    <v-row>
      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="FromStore"
          :items="stores"
          label="From Store"
          item-text="Name"
          item-value="id"
          filled
          readonly
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row dense id="po" class="text--primary subtitle-2">
      <v-col cols="12" class="docForm">
        <v-data-table
          light
          :mobile-breakpoint="0"
          :items-per-page="pageItems"
          :headers="headers"
          :items="orderItems"
          item-key="id"
          hide-default-footer
          single-select
        >
          <template v-slot:item.Name="{ item }">
            <v-autocomplete
              name="posProductName"
              style="width: 350px"
              autocomplete="off"
              dense
              outlined
              single-line
              v-model="item.o_i_t_m_s_id"
              :items="products"
              label="Select Product"
              item-text="Name"
              item-value="id"
              @change="setOrderItem(item)"
            ></v-autocomplete>
          </template>

          <template v-slot:item.Quantity="{ item }">
            <v-text-field
              autocomplete="off"
              type="number"
              class="orderInput"
              single-line
              outlined
              dense
              v-model="item.Quantity"
            ></v-text-field>
          </template>

          <template v-slot:item.BuyingPrice="{ item }">
            <v-text-field
              autocomplete="off"
              type="number"
              class="orderInput"
              single-line
              outlined
              dense
              v-model="item.BuyingPrice"
            ></v-text-field>
          </template>

          <template v-slot:item.ref1="{ item }">
            <v-text-field
              single-line
              outlined
              dense
              v-model="item.ref1"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="ToStore"
          :items="stores"
          label="To Store"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          autocomplete="off"
          dense
          outlined
          v-model="PickedBy"
          :items="users"
          label="Picked By"
          item-text="name"
          item-value="id"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" md="12">
        <v-btn color="accent" @click="save" :loading="loader"> Update </v-btn>
      </v-col>
    </v-row>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </div>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    payments: {
      type: Array,
    },
    walkinCustomer: {
      type: Boolean,
    },
    AccountsVersion: {
      type: String,
    },
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data: () => ({
    record: {},
    Account: null,
    FromStore: null,
    ToStore: null,
    PickedBy: null,
    search: null,
    editDialog: false,
    dateDialog: false,
    Product: null,
    Quantity: null,
    Price: null,
    LineTotal: null,
    editItem: {},
    paymentDialog: false,
    customerDialog: false,
    CardCode: null,
    paymentItem: {},
    taxGroups: [],
    loader: false,
    pageItems: 100,
    selectedProduct: null,
    SumApplied: 0,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    orderItems: [],
    customers: [],
    accounts: [],
    products: [],
    inventory: [],
    stores: [],
    users: [],
    cancelledData: [],
    cancelOption: null,
    date: new Date().toISOString().substr(0, 10),
    CorrectDate: null,
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Ref", value: "ref1" },
    ],
    paymentHeaders: [
      { text: "Payment Mode", value: "o_a_c_t_s_id" },
      { text: "Amount", value: "SumApplied" },
    ],
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
      this.FromStore = val.store_id;
      this.ToStore = val.ToStrCode;
      this.PickedBy = val.UserSign;
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.Name = row.product.Name;
          row.productId = row.product.id;
          products.push(row);
        }
        this.orderItems = products;
      }
    },

    setDate(date) {
      this.CorrectDate = date;
    },
    getProducts() {
      const self = this;
      // const id = this.activeStore;
      this.$store
        .dispatch("get", `/products`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save() {
      const transferItem = this.record;
      let data = {};
      data.FromStore = this.FromStore;
      data.ToStore = this.ToStore;
      data.PickedBy = this.PickedBy;
      data.UserSign2 = this.PickedBy;
      data.rows = this.orderItems;
      const url = `/inventory-transfer/${transferItem.id}`;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.$router.push("/edit/stock/transfer");
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getInventory() {
      const self = this;
      const id = this.activeStore;
      this.$store
        .dispatch("get", `/stores/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.inventory = res.ResponseData.itm2;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customers = res.ResponseData;
            customers.shift();
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/all/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([
      this.getProducts(),
      this.getInventory(),
      this.getCustomers(),
      this.getStores(),
      this.getUsers(),
    ]);
  },
};
</script>

<style  scoped>
/* .v-text-field__details {
  display: none !important;
} */
</style>